import { Modal } from 'antd'
import type { HookAPI } from 'antd/es/modal/useModal'

import MissingSkuReport from '../MissingSkuReport/MissingSkuReport'
import type { StockImportLogModel } from '../types/stockImports.types'
import cn from './MissingSkuModal.module.scss'

interface Props {
  open: boolean
  log: Pick<StockImportLogModel, 'id'> | null
  modal: HookAPI
  onClose: () => void
}

function MissingSkuModal({ open, log, modal, onClose }: Props) {
  return (
    <Modal
      title="Незагруженные позиции"
      open={open}
      centered
      onCancel={onClose}
      footer={null}
      width="min(1480px, calc(100vw - 32px))"
      destroyOnHidden
      wrapClassName={cn.missingSkuModal}
    >
      {log && <MissingSkuReport logId={log.id} modal={modal} />}
    </Modal>
  )
}

export default MissingSkuModal
